import React from 'react'

export const CATEGORIES = [
    {
      id: 1,
      img: require('./images/rind.png'),
      name: <>Rind</>,
      color: '#fcc2ff'
    },
    {
      id: 2,
      img: require('./images/lange geöffnet.png'),
      name: <>lang geöffnet</>,
      color: '#ffabab'
    },
    {
      id: 3,
      img: require('./images/getränke.png'),
      name: <>Getränke</>,
      color: '#b5b9ff'
    },
    {
      id: 4,
      img: require('./images/gluten frei.png'),
      name: <>Gluten frei</>,
      color: '#ffffd1'
    },
    {
      id: 5,
      img: require('./images/fisch.png'),
      name: <>Fisch</>,
      color: '#afcbff'
    },
    {
      id: 6,
      img: require('./images/kein plastik.png'),
      name: <>kein Plastik</>,
      color: '#85e3ff',
    },
    {
      id: 7,
      img: require('./images/gebäck.png'),
      name: <>Gebäck</>,
      color: '#f3ffe3'
    },
    {
      id: 8,
      img: require('./images/schwein.png'),
      name: <>Schwein</>,
      color: '#ffb5e8'
    },
    {
      id: 9,
      img: require('./images/alkohol.png'),
      name: <>Alkohol</>,
      color: '#6eb5ff'
    },
    {
      id: 10,
      img: require('./images/schaf.png'),
      name: <>Schaf</>,
      color: '#f6a6ff'
    },
    {
      id: 11,
      img: require('./images/geflügel.png'),
      name: <>Geflügel</>,
      color: '#fbe4ff'
    },
    {
      id: 12,
      img: require('./images/vegetarisch.png'),
      name: <>Vege<wbr/>tarisch</>,
      color: '#dbffd6'
    },
    {
      id: 13,
      img: require('./images/früchte.png'),
      name: <>Früchte</>,
      color: '#fff5ba'
    },
    {
      id: 14,
      img: require('./images/bekleidung.png'),
      name: <>Beklei<wbr/>dung</>,
      color: '#ffcbc1'
    },
    {
      id: 15,
      img: require('./images/kräuter.png'),
      name: <>Kräuter</>,
      color: '#aff8db'
    },
    {
      id: 16,
      img: require('./images/milchprodukte.png'),
      name: <>Milchpro<wbr/>dukte</>,
      color: '#ace7ff'
    },
    {
      id: 17,
      img: require('./images/vegan.png'),
      name: <>Vegan</>,
      color: '#bffcc6'
    },
    {
      id: 18,
      img: require('./images/bio.png'),
      name: <>Bio</>,
      color: '#e7ffac'
    },
    {
      id: 19,
      img: require('./images/handgemacht.png'),
      name: <>handge<wbr/>macht</>,
      color: '#ffbebc'
    }
  ]